/* eslint-disable camelcase */
import { produce } from 'immer';
import { Store } from 'redux';

import {
  makeSyncReduxWithLocalStorageObserver,
  restoreFromLocalStorage,
} from 'app/dataManagement/syncReduxStateWithLocalStorage';
import observeStore from 'app/utils/redux/observeStore';
import { TeleradiologyAction, UPDATE_TELERADIOLOGY } from './actions';

export const TELERADIOLOGY_LOCAL_STORAGE_KEY = 'redux.teleradiology';

type TeleradiologyState = {
  type?: string;
  affiliateId?: number;
};

/** @var {object} teleradiologyInitialState */
const teleradiologyInitialState = (): TeleradiologyState => ({
  type: undefined,
  affiliateId: undefined,
  ...restoreFromLocalStorage(TELERADIOLOGY_LOCAL_STORAGE_KEY),
});

function teleradiologyReducer(
  state: TeleradiologyState = teleradiologyInitialState(),
  action: TeleradiologyAction
) {
  return produce(state, (draft) => {
    switch (action.type) {
      case UPDATE_TELERADIOLOGY: {
        draft.type = action.teleradiology?.type;
        draft.affiliateId = action.teleradiology?.affiliateId;
        break;
      }
    }
  });
}

type StateWithTeleradiology = {
  teleradiology: TeleradiologyState;
};

export const selectTeleradiology = (state: StateWithTeleradiology) => state.teleradiology;
export const selectTeleradiologyAffiliateId = (state: StateWithTeleradiology) =>
  state.teleradiology.affiliateId;
export const selectTeleradiologyType = (state: StateWithTeleradiology) => state.teleradiology.type;

export const attachTeleradiologyWithLocalStorageSynchronizationObserver = (
  store: Store<StateWithTeleradiology>
) => {
  observeStore(
    store,
    selectTeleradiology,
    makeSyncReduxWithLocalStorageObserver(TELERADIOLOGY_LOCAL_STORAGE_KEY)
  );
};

export default teleradiologyReducer;
